import { combineReducers } from "redux";

import { tripcostsDetails } from "./reducer.tripcosts"
const tripcostsReducers = combineReducers({

    tripcostsDetails

})
export default tripcostsReducers;
